/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type PrintProductRecommendationsQueryVariables = Types.Exact<{
    locale: Types.Scalars['String'];
    imageUrl: Types.Scalars['String'];
}>;

export type PrintProductRecommendationsQuery = {
    __typename: 'Query';
    printProductRecommendations: {
        __typename: 'PrintProductRecommendationsResponse';
        prominentColorOfImage: string;
        recommendedProducts: Array<{
            __typename: 'RecommendedProduct';
            title: string;
            previewImageUrl: string;
            vpProductPageUrl: string;
            mpvId: string;
            estimatedPrice: {
                __typename: 'EstimatedPrice';
                price: number;
                currency: string;
                quantity: string;
            };
        }>;
    };
};

export const PrintProductRecommendationsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'printProductRecommendations' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageUrl' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'printProductRecommendations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'imageUrl' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'imageUrl' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'prominentColorOfImage' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'recommendedProducts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'previewImageUrl' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'vpProductPageUrl' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mpvId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'estimatedPrice' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'price' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'currency',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'quantity',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __usePrintProductRecommendationsQuery__
 *
 * To run a query within a React component, call `usePrintProductRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintProductRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintProductRecommendationsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      imageUrl: // value for 'imageUrl'
 *   },
 * });
 */
export function usePrintProductRecommendationsQuery(
    baseOptions: Apollo.QueryHookOptions<
        PrintProductRecommendationsQuery,
        PrintProductRecommendationsQueryVariables
    >
) {
    return Apollo.useQuery<
        PrintProductRecommendationsQuery,
        PrintProductRecommendationsQueryVariables
    >(PrintProductRecommendationsDocument, baseOptions);
}
export function usePrintProductRecommendationsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PrintProductRecommendationsQuery,
        PrintProductRecommendationsQueryVariables
    >
) {
    return Apollo.useLazyQuery<
        PrintProductRecommendationsQuery,
        PrintProductRecommendationsQueryVariables
    >(PrintProductRecommendationsDocument, baseOptions);
}
export type PrintProductRecommendationsQueryHookResult = ReturnType<
    typeof usePrintProductRecommendationsQuery
>;
export type PrintProductRecommendationsLazyQueryHookResult = ReturnType<
    typeof usePrintProductRecommendationsLazyQuery
>;
export type PrintProductRecommendationsQueryResult = Apollo.QueryResult<
    PrintProductRecommendationsQuery,
    PrintProductRecommendationsQueryVariables
>;
